import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../app/state/app.selectors';
import * as fromEinConfiguration from './ein-configuration.reducers';

export interface EinConfigurationState {
  stateData: fromEinConfiguration.State;
}

export interface State extends fromRoot.AppState {
  einConfiguration: EinConfigurationState;
}

export const reducers = {
  stateData: fromEinConfiguration.reducer
};

export const selectEinConfigurationState = createFeatureSelector<EinConfigurationState>('einConfiguration');

export const selectEinConfigurationStateData = createSelector(selectEinConfigurationState, (state: EinConfigurationState) => state.stateData);

export const getEinConfigurationState = createSelector(selectEinConfigurationStateData, fromEinConfiguration.getEinConfig);

export const getEinConfigurationScreenError = createSelector(selectEinConfigurationStateData, fromEinConfiguration.getError);

export const getEinConfigurationScreenPending = createSelector(selectEinConfigurationStateData, fromEinConfiguration.getPending);